import { Popover, PopoverProps } from '../Popover'

export const ActionSheet: React.FC<PopoverProps> = (props) => (
  <Popover {...props} />
)
